import gql from "graphql-tag";

export const moveCatalogCategoryMutation = gql`
  mutation MoveCatalogCategory($id: ID!, $newParentId: ID, $orderedIds: [ID!]!) {
    moveCatalogCategory(id: $id, newParentId: $newParentId, orderedIds: $orderedIds) {
      id
      name
      parentId
      sort
      createdAt
    }
  }
`;
